import { PageHeader } from '@/components/PageHeader';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import AdvancedParsingAnalytics from '@/components/AdvancedParsingAnalytics';
import EnhancedErrorRecoverySystem from '@/components/EnhancedErrorRecoverySystem';
import AdvancedExtractionInterface from '@/components/AdvancedExtractionInterface';

export default function AdvancedExtraction() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Advanced Extraction & Recovery"
        description="AI-powered bill extraction with advanced analytics and error recovery"
      />
      
      <Tabs defaultValue="interface" className="space-y-6">
        <TabsList>
          <TabsTrigger value="interface">Extraction Engine</TabsTrigger>
          <TabsTrigger value="analytics">Analytics Dashboard</TabsTrigger>
          <TabsTrigger value="recovery">Error Recovery</TabsTrigger>
        </TabsList>
        
        <TabsContent value="interface">
          <AdvancedExtractionInterface />
        </TabsContent>
        
        <TabsContent value="analytics">
          <AdvancedParsingAnalytics />
        </TabsContent>
        
        <TabsContent value="recovery">
          <EnhancedErrorRecoverySystem />
        </TabsContent>
      </Tabs>
    </div>
  );
}